import { Log, UserManager, WebStorageStateStore, WebStorageStateStoreSettings } from 'oidc-client-ts'
import store from '../../store.js'

const settings =
{
  prefix: 'popupAuthStore.',
  store: window.sessionStorage
}
const url = window.location.origin
const defaultSettings = {
  authority: '',
  client_id: '',
  popup_redirect_uri: `${url}/popup-callback`,
  popup_post_logout_redirect_uri: `${url}/popuplogout-callback`,
  response_type: 'code',
  scope: '',
  prompt: '',
  monitorSession: false,
  // iframeScriptOrigin: '*',
  userStore: new WebStorageStateStore(settings)
}

class PopupAuth {
  constructor(customSettings, apiBaseUrl) {
    // This helps to debug UserManager issues
    /* Log.setLogger(console)
    Log.setLevel(Log.INFO) */
    // const url = window.location.origin
    this.addUserLoadedEvent = null
    this.addUserUnloadedEvent = null
    this.setSettings(customSettings, apiBaseUrl)
    /* const settings = customSettings ? { ...defaultSettings, ...customSettings } : defaultSettings

    this.userManager = new UserManager(settings)

    this.userManager.metadataService.getEndSessionEndpoint().then(url => { this.canEndSession = !!url })
    this.userManager.clearStaleState() */
  }

  getSettings() {
    return this.settings
  }

  setSettings(customSettings, apiBaseUrl) {
    this.settings = customSettings ? { ...defaultSettings, ...customSettings } : defaultSettings
    // this.settings.apiBaseUrl = apiBaseUrl

    try {
      this.userManager = new UserManager(this.settings)
    } catch {
    }

    this.reInitEvents()
  }

  async getUser() {
    const user = await this.userManager.getUser()
    return user
  }

  async login(state) {
    const result = await this.userManager.signinPopup({
      state
    })
    return result
  }

  async handleLoginCallback() {
    const user = await this.userManager.signinCallback()
    return user
  }

  async handlePopupLogoutCallback() {
    // console.log('popupauth handlePopupLogoutCallback called')
    const user = await this.userManager.signoutCallback()
    return user
  }

  async logout() {
    try {
      // console.log('popupauth handlePopupLogoutCallback called')
      const canEndSession = await this._canEndSession()
      // console.log('popupauth canEndSession', canEndSession)
      if (canEndSession) {
        await Promise.race([
          this.userManager.signoutPopup(),
          new Promise((_resolve, reject) =>
            setTimeout(() => reject(new Error('Signout popup timed out')), 5000)
          )
        ])
      }
    } catch (error) {
      console.warn('popup logout warning (non-fatal):', error)
    } finally {
      await this.userManager.removeUser()
      store.commit('removeExternalProviderDetails')
    }
  }

  async _canEndSession() {
    try {
      const metadata = await this.userManager.metadataService.getMetadata()
      return !!metadata.end_session_endpoint
    } catch {
      return false
    }
  }

  async getAccessToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.access_token
  }

  async getIdToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.id_token
  }

  addUserLoaded(func) {
    this.addUserLoadedEvent = func
    if (this.userManager && func) {
      this.userManager.events.addUserLoaded(func)
    }
  }

  addUserUnloaded(func) {
    this.addUserUnloadedEvent = func
    if (this.userManager && func) {
      this.userManager.events.addUserUnloaded(func)
    }
  }

  reInitEvents() {
    if (this.userManager) {
      if (this.addUserLoadedEvent) {
        this.userManager.events.removeUserLoaded(this.addUserLoadedEvent)
      }
      if (this.addUserUnloadedEvent) {
        this.userManager.events.removeUserUnloaded(this.addUserUnloadedEvent)
      }

      if (this.addUserLoadedEvent) {
        this.userManager.events.addUserLoaded(this.addUserLoadedEvent)
      }
      if (this.addUserUnloadedEvent) {
        this.userManager.events.addUserUnloaded(this.addUserUnloadedEvent)
      }
    }

    if (this.userManager) {
      // this.userManager.metadataService.getEndSessionEndpoint().then(url => { this.canEndSession = !!url })
      this.userManager.clearStaleState()
    }
  }

  async _getRefreshingUser(forceRefresh = false) {
    let user = await this.userManager.getUser()
    if (forceRefresh || !user || user.expired) {
      try {
        user = await this.userManager.signinSilent()
      } catch (error) {
        await this.userManager.removeUser()
        throw error
      }
    }

    return user
  }
}

async function createPopupAuth(customSettings) {
  return new PopupAuth(customSettings)
}

export default createPopupAuth
